// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CqfoL","questions":"styles_questions__h_i4v","footer":"styles_footer__1smwv"};